import axiosInstance from "../models/axiosInstance";
import { interceptor } from "../interceptors/axiosInterceptor";
import APIServiceExtended from "./apiServicesExtended";

interceptor(axiosInstance.APIInstance);

const getCreatedTPRequestsService = () => {
  return {
    instance: axiosInstance.APIInstance,
    method: "get",
    url: `/businessUser/getTPRequests`,
  };
};

const downloadFile = (file,page) => {
  let data = {
    FileName: file,
    profile:page
  }
  return {
    instance: axiosInstance.APIInstance,
    method: "post",
    headers: {
      responseType: "blob",
    },
    url: `/controlAssessment/downloadEvidence`,
    body:data
  };
};

const downloadTemplate = () => {
  return {
    instance: axiosInstance.APIInstance,
    method: "post",
    headers: {
      responseType: "blob",
    },
    url: `/user/downloadTemplate`,
  };
};

const verifyIdamLogin = (data) => {
  return {
    instance: axiosInstance.APIInstance,
    method: "post",
    url: `/login/verifyIdamLogin`,
    body: data,
  };
};
const getAssessmentUnitUserList = () => {
  return {
    instance: axiosInstance.APIInstance,
    method: "get",
    url: `/clientadmin/userlist`,
  };
};

const idamSuccess = (data) => {
  return {
    instance: axiosInstance.APIInstance,
    method: "get",
    url: `/login/idamSuccess/jwtKey?code=${data.code}`,
  };
};

const IdamLoginManager = (data) => {
  return {
    instance: axiosInstance.APIInstance,
    method: "post",
    url: `/login/IdamLoginManager`,
    body: data,
  };
};

const getEmailsByRoleID = (id) => {
  let data = {
    ID: id
  }
  return {
    instance: axiosInstance.APIInstance,
    method: "post",
    url: `/common/getEmailByRoleId`,
    body: data
  };
};
const getAuditsByRoleID = () => {
  return {
    instance: axiosInstance.APIInstance,
    method: "get",
    url: `/auditHistory/getAuditHistory`,
  };
};
const getNotifcationsByRoleID = () => {
  return {
    instance: axiosInstance.APIInstance,
    method: "get",
    url: `/notifcation/getNotifcationsByRoleID`,
  };
};
const getNotifcationsCount = () => {
  return {
    instance: axiosInstance.APIInstance,
    method: "get",
    url: `/notifcation/getNotifcationsCount`,
  };
};
const getAllCtrlWPCategoryList = () => {
  return {
    instance: axiosInstance.APIInstance,
    method: "get",
    url: `/masterRepository/getAllWPCategoryList`,
  };
};
const deleteCtrlWorkProgramById = (data) => {
  return {
    instance: axiosInstance.APIInstance,
    method: "put",
    url: `/masterRepository/deleteCtrlWorkProgram`,
    body: data
  };
};
const updateCtrlWorkProgram = (body) => {
  return {
    instance: axiosInstance.APIInstance,
    method: "put",
    url: `/masterRepository/editCtrlWorkProgram`,
    body: body,
  };
};
const getCtrlWorkProgramById = (wpID) => {
  let data = {
    wpID: wpID
  }
  return {
    instance: axiosInstance.APIInstance,
    method: "post",
    url: `/masterRepository/getCtrlWorkProgramById`,
    body: data
  };
};
const getAllControlWorkProgram = () => {
  return {
    instance: axiosInstance.APIInstance,
    method: "get",
    url: `/masterRepository/getAllControlWorkProgram`,
  };
};
const getmasterWorkPrograms = (orgId) => {
  return {
    instance: axiosInstance.APIInstance,
    method: "get",
    url: `/common/getmsWorkPrograms/?orgId=${orgId}`,
  };
};
const createCtrlWorkProgram = (data) => {
  return {
    instance: axiosInstance.APIInstance,
    method: "post",
    url: `/masterRepository/createCtrlWorkProgram`,
    body: data,
  };
};
const handleNotificationSubmit = (data) => {
  return {
    instance: axiosInstance.APIInstance,
    method: "post",
    url: `/notifcation/postNotifcations`,
    body: data,
  };
};
const createmasterWorkProgram = (data) => {
  return {
    instance: axiosInstance.APIInstance,
    method: "post",
    url: `/common/createmasterProgram`,
    body: data,
  };
};
const closeViewIssue = (data) => {
  return {
    instance: axiosInstance.APIInstance,
    method: "post",
    url: `/issues/editRequestClosure`,
    body: data,
  };
};
const manageViewIssue = (data) => {
  return {
    instance: axiosInstance.APIInstance,
    method: "post",
    url: `/issues/editManageIssue`,
    body: data,
  };
};
const requestViewIssue = (data) => {
  return {
    instance: axiosInstance.APIInstance,
    method: "post",
    url: `/issues/requestViewIssue`,
    body: data,
  };
};
const approvalViewIssue = (body) => {
  return {
    instance: axiosInstance.APIInstance,
    method: "put",
    url: `/issues/approveAnalystIssues`,
    body: body,
  };
};
const updateViewIssues = (body) => {
  return {
    instance: axiosInstance.APIInstance,
    method: "put",
    url: `/issues/updateIssues`,
    body: body,
  };
};
const deleteIssueRequestByID = (issueID) => {
  let data = {
    issueID: issueID,
    email:sessionStorage.getItem("email"),

  }
  return {
    instance: axiosInstance.APIInstance,
    method: "put",
    url: `/issues/deleteIssueRequest`,
    body: data
  };
};
const getIssueById = (issueID,actionId) => {
  let data = {
    issueID: issueID,
    actionId:actionId
  }
  return {
    instance: axiosInstance.APIInstance,
    method: "post",
    url: `/issues/getIssueById`,
    body: data
  };
};
const getViewAllIssues = () => {
  return {
    instance: axiosInstance.APIInstance,
    method: "get",
    url: `/issues/getViewAllIssues/`,
  };
};
const getCloseIssuesRequests = () => {
  return {
    instance: axiosInstance.APIInstance,
    method: "get",
    url: `/issues/getCloseIssuesRequests`,
  };
};
const getManageIssuesRequests = () => {
  return {
    instance: axiosInstance.APIInstance,
    method: "get",
    url: `/issues/getManageIssuesRequests`,
  };
};
const getAllVendorViewIssues = (vendorid) => {
  const data={
    vendorid:vendorid
  }
  return {
    instance: axiosInstance.APIInstance,
    method: "post",
    url: `/issues/getAllVendorViewIssues`,
    body: data,
    
  };
};
const getViewActionRequests = () => {
  return {
    instance: axiosInstance.APIInstance,
    method: "get",
    url: `/issues/getViewActionRequests`,
  };
};
const getViewUpdateRequests = () => {
  return {
    instance: axiosInstance.APIInstance,
    method: "get",
    url: `/issues/getViewUpdateRequests`,
  };
};
const getAllViewIssues = () => {
  return {
    instance: axiosInstance.APIInstance,
    method: "get",
    url: `/issues/getAllViewIssues`,
  };
};

const loginValidate = (payload) => {
  return {
    instance: axiosInstance.APIInstance,
    method: "post",
    url: `/login`,
    body: payload,
  };
};

const loginValidateOTP = (payload) => {
  return {
    instance: axiosInstance.APIInstance,
    method: "post",
    url: `/login/validateotplogin`,
    body: payload,
  };
};

const resetPassword = (body) => {
  return {
    instance: axiosInstance.APIInstance,
    method: "post",
    url: `/login/sendLinkForPasswordReset`,
    body: body,
  };
};

const resetNewPassword = (body) => {
  return {
    instance: axiosInstance.APIInstance,
    method: "post",
    url: `/login/resetNewPassword`,
    body: body,
  };
};

const resetNewPasswordEmailValidation = (body) => {
  return {
    instance: axiosInstance.APIInstance,
    method: "post",
    url: `/login/resetNewPasswordEmailValidation`,
    body: body,
  };
};

const clearLoginSession = (body) => {
  return {
    instance: axiosInstance.APIInstance,
    method: "post",
    url: `/login/clearLoginSession`,
    body: body,
  };
};

const vendorRegistration = (data) => {
  return {
    instance: axiosInstance.APIInstance,
    method: "post",
    url: `/vendor/create`,
    body: data,
  };
};

const getAllVendorList = () => {
  return {
    instance: axiosInstance.APIInstance,
    method: "get",
    url: `/vendor`,
  };
};

const getAllVendorListAdmin = () => {
  return {
    instance: axiosInstance.APIInstance,
    method: "get",
    url: `/vendor/admin`
  }
}

const getriskvendorlist = () => {
  return {
    instance: axiosInstance.APIInstance,
    method: "get",
    url: `/vendor/getRiskVendorList`,
  };
};

const getAllAssessmentVendorList = () => {
  return {
    instance: axiosInstance.APIInstance,
    method: "get",
    url: `/vendor/existvendors`,
  };
};

const getAllBusinessUnitList = () => {
  return {
    instance: axiosInstance.APIInstance,
    method: "get",
    url: `/vendor/getAllBusinessUnitList`,
  };
};

const getAllSubBusinessUnitList = () => {
  return {
    instance: axiosInstance.APIInstance,
    method: "get",
    url: `/vendor/getAllSubBusinessUnitList`,
  };
};

const deleteVendorRecord = (vendorId, vendorUserId) => {
  let data = {
    ID: vendorId,
    VID: vendorUserId
  }
  return {
    instance: axiosInstance.APIInstance,
    method: "post",
    url: `/vendor/deletevendorrecord`,
    body: data
  };
};

const updateRecordById = (data) => {
  return {
    instance: axiosInstance.APIInstance,
    method: "put",
    url: `/vendor/updatevendorrecord/`,
    body: data,
  };
};

const getVendorRecordsById = (vendorId, vendorUserId) => {
  let data = {
    ID: vendorId,
    VID: vendorUserId
  }
  return {
    instance: axiosInstance.APIInstance,
    method: "post",
    url: `/vendor/vendorId`,
    body: data
  };
};

const userRegistration = (data) => {
  return {
    instance: axiosInstance.APIInstance,
    method: "post",
    url: `/user/create`,
    body: data,
  };
};

const getAllUserList = () => {
  return {
    instance: axiosInstance.APIInstance,
    method: "get",
    url: `/user`,
  };
};

const deleteUserRecord = (data) => {
  return {
    instance: axiosInstance.APIInstance,
    method: "put",
    url: `/user/deleteuserrecord`,
    body: data,
  };
};

const getUserRecordsById = (orgid, roleid) => {
  let data = {
    Org: orgid,
    Role: roleid
  }
  return {
    instance: axiosInstance.APIInstance,
    method: "post",
    url: `/user/getuser`,
    body: data
  };
};

const getRoles = () => {
  return {
    instance: axiosInstance.APIInstance,
    method: "get",
    url: `/user/getuserroles`,
  };
};

const getUserList = () => {
  return {
    instance: axiosInstance.APIInstance,
    method: "get",
    url: `/user/getuserslist`,
  };
};

const FetchOrgRoles = () => {
  return {
    instance: axiosInstance.APIInstance,
    method: "get",
    url: `/organization/ReadAllRoles`,
  };
};

const fetchAllOrganizations = () => {
  return {
    instance: axiosInstance.APIInstance,
    method: "get",
    url: `/organization`,
  };
};

const addNewOrganization = (body) => {
  return {
    instance: axiosInstance.APIInstance,
    method: "post",
    url: `/organization/create`,
    body: body,
  };
};

const editOrganization = (body) => {
  return {
    instance: axiosInstance.APIInstance,
    method: "put",
    url: `/organization/EditOrganization`,
    body: body,
  };
};

const AddrolesToOrganization = (body) => {
  return {
    instance: axiosInstance.APIInstance,
    method: "post",
    url: `/organization/AddRole`,
    body: body,
  };
};

const deleteOrganization = (body) => {
  return {
    instance: axiosInstance.APIInstance,
    method: "put",
    url: `/organization/DeleteOrganization`,
    body: body,
  };
};

const DeleteRoles = (body) => {
  return {
    instance: axiosInstance.APIInstance,
    method: "put",
    url: `/organization/Deleteroles`,
    body: body,
  };
};

const EditrolesToOrganization = (body) => {
  return {
    instance: axiosInstance.APIInstance,
    method: "post",
    url: `/organization/EditRole`,
    body: body,
  };
};

const getExistRolesById = (orgID) => {
  let data = {
    ID: orgID
  }
  return {
    instance: axiosInstance.APIInstance,
    method: "post",
    url: `/organization/ReadRolesById`,
    body: data
  };
};

const getOrgDetailsById = (orgID) => {
  let data = {
    ID: orgID
  }
  return {
    instance: axiosInstance.APIInstance,
    method: "post",
    url: `/organization/orgDetailsById`,
    body: data
  };
};

const assignUsers = (body) => {
  return {
    instance: axiosInstance.APIInstance,
    method: "post",
    url: `/organization/AddUsers`,
    body: body,
  };
};

const fetchSelfAssessmentList = (userID) => {
  return {
    instance: axiosInstance.APIInstance,
    method: "get",
    url: `/controlAssessment/getSelfAssessments`,
  };
};

const getWorkprogramCategoryData = (userId) => {
  let data = {
    ID: userId
  }
  return {
    instance: axiosInstance.APIInstance,
    method: "post",
    url: `/controlAssessment/getWorkprogramCategory`,
    body: data
  };
};

const fetchUpdateSelfAssessmentList = () => {
  return {
    instance: axiosInstance.APIInstance,
    method: "get",
    url: `/controlAssessment/getUpdateSelfAssessments`,
  };
};

const getSelfAssessmentById = (id) => {
  let data = {
    ID: id
  }
  return {
    instance: axiosInstance.APIInstance,
    method: "post",
    url: `/controlAssessment/getSelfAssessmentDetails`,
    body: data
  };
};

const getUpdatedSelfAssessmentByID = (id) => {
  let data = {
    Id: id
  }
  return {
    instance: axiosInstance.APIInstance,
    method: "post",
    url: `/controlAssessment/getUpdateSelfAssessmentDetails`,
    body: data
  };
};

const getConductedAssessmentData = (WPId, ASMId) => {
  let data = {
    wpID: WPId,
    asmID: ASMId 
  }
  return {
    instance: axiosInstance.APIInstance,
    method: "post",
    url: `/controlAssessment/getConductedAssessment`,
    body: data
  };
};

const getAssessmentByWPID = (id) => {
  let data = {
    wpId: id
  }
  return {
    instance: axiosInstance.APIInstance,
    method: "post",
    url: `/controlAssessment/getAssessmentDetailsByWPID`,
    body: data
  };
};

const deleteRiskRequestByID = (riskID) => {
  let data = {
    riskID: riskID
  }
  return {
    instance: axiosInstance.APIInstance,
    method: "put",
    url: `/riskAssessment/deleteRiskRequest`,
    body: data
  }
}

const updateSelfAssessment = (data) => {
  return {
    instance: axiosInstance.APIInstance,
    method: "put",
    url: `/controlAssessment/updateSelfAssessmentData`,
    body: data,
  };
};

const getAllTPRequests = () => {
  return {
    instance: axiosInstance.APIInstance,
    method: "get",
    url: `/analyst/getAllTPRequest`,
  };
};

const getAnalystWorkPrograms = () => {
  return {
    instance: axiosInstance.APIInstance,
    method: "get",
    url: `/analyst/getWorkprograms`,
  };
};

const getAssessmentList = () => {
  return {
    instance: axiosInstance.APIInstance,
    method: "get",
    url: `/analyst/getAssessmentList`,
  };
};

const getTPRequestById = (id) => {
  let data = {
    Id: id
  }
  return {
    instance: axiosInstance.APIInstance,
    method: "post",
    url: `/analyst/getThirdPartyRequestById`,
    body: data
  };
};

const getWorkProgramDetailsById = (Id, vendorid) => {
  let data = {
    ID: Id,
    vendorid: vendorid
  }
  return {
    instance: axiosInstance.APIInstance,
    method: "post",
    url: `/analyst/getWorkProgramDetailsById`,
    body: data
  };
};

const createWorkProgram = (data) => {
  return {
    instance: axiosInstance.APIInstance,
    method: "post",
    url: `/analyst/createProgram`,
    body: data,
  };
};

const getExcelTableDate = (data) => {
  return {
    instance: axiosInstance.APIInstance,
    method: "post",
    url: `/analyst/getExcelTableDate`,
    body: data,
  };
};

const createAssessment = (data) => {
  return {
    instance: axiosInstance.APIInstance,
    method: "post",
    url: `/analyst/createPlan`,
    body: data,
  };
};

const deleteTPRequest = (data) => {
  return {
    instance: axiosInstance.APIInstance,
    method: "put",
    url: `/analyst/deleteTPRequest`,
    body: data,
  };
};

const deleteAssessmentPlan = (data) => {
  return {
    instance: axiosInstance.APIInstance,
    method: "put",
    url: `/analyst/deleteAssessmentPlan`,
    body: data,
  };
};

const addFile = (data) => {
  return {
    instance: axiosInstance.APIInstance,
    method: "post",
    url: `/analyst/addFile`,
    body: data,
  };
};

const saveEvidence = (data) => {
  return {
    instance: axiosInstance.APIInstance,
    method: "post",
    url: `/controlAssessment/saveEvidence`,
    body: data,
  };
};

const saveEvidenceIssue = (data) => {
  return {
    instance: axiosInstance.APIInstance,
    method: "post",
    url: `/controlAssessment/saveEvidenceIssue`,
    body: data,
  };
};

const getAllFiles = (type) => {
  let data = {
    id: type
  }
  return {
    instance: axiosInstance.APIInstance,
    method: "post",
    url: `/analyst/getAllFiles`,
    body: data
  };
};

const createNewTPRequest = (data) => {
  return {
    instance: axiosInstance.APIInstance,
    method: "post",
    url: `/businessUser/createTPRequest`,
    body: data,
  };
};

const getTPDataById = (ID) => {
  let id = {
    ID: ID
  }
  return {
    instance: axiosInstance.APIInstance,
    method: "post",
    url: `/businessUser/getTPDataById`,
    body: id
  };
};

const updateTPRequest = (data) => {
  return {
    instance: axiosInstance.APIInstance,
    method: "put",
    url: `/businessUser/updateTPRequest`,
    body: data,
  };
};

const getAllQuestionsList = (orgId) => {
  const data={
    orgId:orgId
  }
  return {
    instance: axiosInstance.APIInstance,
    method: "post",
    url: `/businessUser/getAllQuestionsList`,
    body: data,
  };
};

const deleteTPRequestData = (data) => {
  return {
    instance: axiosInstance.APIInstance,
    method: "post",
    url: `/businessUser/deleteTPDataRequest`,
    body: data,
  };
};

const getSelectedVendorAddress = (data) => {
  return {
    instance: axiosInstance.APIInstance,
    method: "post",
    url: `/businessUser/getSelectedVendorAddress`,
    body: data,
  };
};

const getTPListDetails = (Id) => {
  let id = {
    thirdPartyId: Id
  }
  return {
    instance: axiosInstance.APIInstance,
    method: "post",
    url: `/businessUser/getTPListDetails`,
    body: id
  };
};

const getTPContactInfo = (id) => {
  let data = {
    tPUserId: id
  }
  return {
    instance: axiosInstance.APIInstance,
    method: "post",
    url: `/businessUser/getTPContactInfo`,
    body: data
  };
};

const getSelectedThirdPartyDetails = () => {
  return {
    instance: axiosInstance.APIInstance,
    method: "get",
    url: `/businessUser/getSelectedThirdPartyDetails`,
  };
};

const getPlanRequests = () => {
  return {
    instance: axiosInstance.APIInstance,
    method: "get",
    url: `/manager/getPlanRequests`
  };
};

const getWorkPrograms = () => {
  return {
    instance: axiosInstance.APIInstance,
    method: "get",
    url: `/manager/getWorkPrograms`,
  };
};

const selectWorkPrograms = (orgId, vendorid) => {
  let data = {
    wpID: orgId,
    vendorid: vendorid
  }
  return {
    instance: axiosInstance.APIInstance,
    method: "post",
    url: `/manager/selectWorkPrograms`,
    body: data
  }
}

const updatePlanRequest = (body) => {
  return {
    instance: axiosInstance.APIInstance,
    method: "post",
    url: `/manager/updatePlanRequest`,
    body: body
  }
}

const updateWorkProgramRequest = (body) => {
  return {
    instance: axiosInstance.APIInstance,
    method: "put",
    url: `/manager/updateWorkProgramRequest`,
    body: body
  }
}

const deletePlanRequest = (body) => {
  return {
    instance: axiosInstance.APIInstance,
    method: "put",
    url: `/manager/deletePlanRequest`,
    body: body
  }
}

const deleteWorkProgramRequest = (body) => {
  return {
    instance: axiosInstance.APIInstance,
    method: "put",
    url: `/manager/deleteWorkProgramRequest`,
    body: body
  }
}

const getSelfAssessments = () => {
  return {
    instance: axiosInstance.APIInstance,
    method: "get",
    url: `/controlAssessment/getSelfAssessmentsforAssessor`
  }
}

const getOnSiteAssessments = () => {
  return {
    instance: axiosInstance.APIInstance,
    method: "get",
    url: `/controlAssessment/getOnSiteAssessments`
  }
}

const getInitiatedOnsiteAssessments = () => {
  return {
    instance: axiosInstance.APIInstance,
    method: "get",
    url: `/controlAssessment/getInitiatedOnsites`
  }
}

const initiateSelfAssessment = (data) => {
  return {
    instance: axiosInstance.APIInstance,
    method: "post",
    url: `/controlAssessment/initiateSelfAssessment`,
    body: data
  }
}

const approveSelfAssessment = (data) => {
  return {
    instance: axiosInstance.APIInstance,
    method: "post",
    url: `/controlAssessment/approveSelfAssessment`,
    body: data
  }
}

const initiateOnsiteAssessment = (data) => {
  return {
    instance: axiosInstance.APIInstance,
    method: "post",
    url: `/controlAssessment/initiateOnsiteAssessment`,
    body: data
  }
}

const getStatus = () => {
  return {
    instance: axiosInstance.APIInstance,
    method: "get",
    url: `/common/getStatus`
  }
}

const getAllBUUsersList = () => {
  return {
    instance: axiosInstance.APIInstance,
    method: "get",
    url: `/common/getAllBUUsersList`
  }
}

const getAllPriorityLevels = () => {
  return {
    instance: axiosInstance.APIInstance,
    method: "get",
    url: `/common/getAllPriorityLevels`
  }
}

const getCriticalityList = () => {
  return {
    instance: axiosInstance.APIInstance,
    method: "get",
    url: `/common/getCriticalityList`
  }
}

const getVendors = () => {
  return {
    instance: axiosInstance.APIInstance,
    method: "get",
    url: `/common/getVendors`
  }
}

const getCategoryList = () => {
  return {
    instance: axiosInstance.APIInstance,
    method: "get",
    url: `/common/getCategoryList`
  }
}

const getManagerEmails = (ID) => {
  let data = {
    ID: ID
  }
  return {
    instance: axiosInstance.APIInstance,
    method: "post",
    url: `/common/getManagerEmail`,
    body: data
  }
}

const getAssessorEmails = (ID) => {
  let data = {
    ID: ID
  }
  return {
    instance: axiosInstance.APIInstance,
    method: "post",
    url: `/common/getAssessorEmail`,
    body: data
  }
}

const getProfileDataByUserId = (ID) => {
  return {
    instance: axiosInstance.APIInstance,
    method: "post",
    url: `/common/getProfileData`,
    body: ID
  }
}

const getAllBUAssessmentTypeList = () => {
  return {
    instance: axiosInstance.APIInstance,
    method: "get",
    url: `/common/getAllBUAssessmentTypeList`
  }
}

const getAllBUFrequencyList = () => {
  return {
    instance: axiosInstance.APIInstance,
    method: "get",
    url: `/common/getAllBUFrequencyList`
  }
}

const getAllBURecurrenceList = () => {
  return {
    instance: axiosInstance.APIInstance,
    method: "get",
    url: `/common/getAllBURecurrenceList`
  }
}

const getAllManagersList = () => {
  return {
    instance: axiosInstance.APIInstance,
    method: "get",
    url: `/common/getManagers`
  }
}

const getAllAssessorsList = () => {
  return {
    instance: axiosInstance.APIInstance,
    method: "get",
    url: `/common/getAssessors`
  }
}

const getAllClassifications = () => {
  return {
    instance: axiosInstance.APIInstance,
    method: "get",
    url: `/common/getClassifications`
  }
}

const createRiskRequest = (data) => {
  return {
    instance: axiosInstance.APIInstance,
    method: "post",
    url: `/riskAssessment/create`,
    body: data
  }
}

const getBusinessImpactAnalysis = () => {
  return {
    instance: axiosInstance.APIInstance,
    method: "get",
    url: `/riskAssessment/getBusinessImpactAnalysis`
  }
}

const getBIAReviewData = () => {
  return {
    instance: axiosInstance.APIInstance,
    method: "get",
    url: `/riskAssessment/getBIAReviewData`
  }
}

const getAllRiskData = () => {
  return {
    instance: axiosInstance.APIInstance,
    method: "get",
    url: `/riskAssessment/getAllRiskData`
  }
}

const getBusinessImpactByID = (riskID) => {
  let data = {
    riskID: riskID,
    roleID: Number(sessionStorage.getItem("roleId"))
  }
  return {
    instance: axiosInstance.APIInstance,
    method: "post",
    url: `/riskAssessment/getBusinessImpactByID`,
    body: data
  }
}

const updateSelectedBusinessImpact = (body) => {
  return {
    instance: axiosInstance.APIInstance,
    method: "put",
    url: `/riskAssessment/editBusinessImpact`,
    body: body
  }
}

const updateRiskRequest = (body) => {
  return {
    instance: axiosInstance.APIInstance,
    method: "put",
    url: `/riskAssessment/editRik`,
    body: body
  }
}

const reviewSelectedBusinessImpact = (body) => {
  return {
    instance: axiosInstance.APIInstance,
    method: "put",
    url: `/riskAssessment/reviewBusinessImpact`,
    body: body
  }
}

const getRiskRequestData = () => {
  return {
    instance: axiosInstance.APIInstance,
    method: "get",
    url: `/riskAssessment/getRiskRequest`
  }
}

const getManageRiskData = () => {
  return {
    instance: axiosInstance.APIInstance,
    method: "get",
    url: `/riskTracking/getManageRiskData`
  }
}

const getManageRiskById = (riskID) => {
  let data = {
    ID: riskID
  }
  return {
    instance: axiosInstance.APIInstance,
    method: "post",
    url: `/riskTracking/getManageRiskById`,
    body: data
  }
}

const getAssessmentRiskById = (thirdPartyId) => {
  let data = {
    ID: thirdPartyId
  }
  return {
    instance: axiosInstance.APIInstance,
    method: "post",
    url: `/riskTracking/getAssessmentRiskById`,
    body: data
  }
}

const getRiskDataById = (thirdPartyId) => {
  let data = {
    ID: thirdPartyId
  }
  return {
    instance: axiosInstance.APIInstance,
    method: "post",
    url: `/riskTracking/getRiskDataById`,
    body: data
  }
}

const updateManageRiskById = (body) => {
  return {
    instance: axiosInstance.APIInstance,
    method: "put",
    url: `/riskTracking/editManageRiskById`,
    body: body
  }
}

const getChangeRequestsRiskData = () => {
  return {
    instance: axiosInstance.APIInstance,
    method: "get",
    url: `/riskTracking/getChangeRequestsRiskData`
  }
}

const getChangeRequestsRiskByID = (riskID) => {
  let data = {
    ID: riskID
  }
  return {
    instance: axiosInstance.APIInstance,
    method: "post",
    url: `/riskTracking/getChangeRequestsRiskByID`,
    body: data
  }
}

const updateRiskRequestById = (body) => {
  return {
    instance: axiosInstance.APIInstance,
    method: "put",
    url: `/riskTracking/editRiskRequestById`,
    body: body
  }
}

const getRiskChangeRequestData = () => {
  return {
    instance: axiosInstance.APIInstance,
    method: "get",
    url: `/riskTracking/getRiskChangeRequestData`
  }
}

const getRiskChangeRequestByID = (riskID) => {
  let data = {
    ID: riskID
  }
  return {
    instance: axiosInstance.APIInstance,
    method: "post",
    url: `/riskTracking/getRiskChangeRequestByID`,
    body: data
  }
}

const updateRiskApprovalById = (body) => {
  return {
    instance: axiosInstance.APIInstance,
    method: "put",
    url: `/riskTracking/editRiskApprovalById`,
    body: body
  }
}

const getExistedGraphsData = (ID) => {
  let data = {
    id: ID
  }
  return {
    instance: axiosInstance.APIInstance,
    method: "post",
    url: `/dashboard/getExistedGraphs`,
    body: data
  }
}

const deleteAssessmentPlanByAssessor = (data) => {
  return {
    instance: axiosInstance.APIInstance,
    method: "put",
    url: `/controlAssessment/DeleteSelfAssessment`,
    body: data
  }
}

const getUnlockUsers = () => {
  return {
    instance: axiosInstance.APIInstance,
    method: "get",
    url: `/user/getlockedusers`
  }
}

const unlockUser = (ID) => {
  let data = {
    ID: ID
  }
  return {
    instance: axiosInstance.APIInstance,
    method: "put",
    url: `/user/unlockuser`,
    body: data
  }
}

const getUsersListEdit = () => {
  return {
    instance: axiosInstance.APIInstance,
    method: "get",
    url:`/user/getuserslistedit`
  }
}

const editUsers = (data) => {
  return {
    instance: axiosInstance.APIInstance,
    method: "post",
    url: `/user/edituserdetails`,
    body: data
  }
}

const  getAreaWiseCount= (ID,category) => {
  let data = {
    ID: ID,
    category:category
  }
  return {
    instance: axiosInstance.APIInstance,
    method: "post",
    url: `/common/getAllAreaWiseCount`,
    body: data
  }
}
const questionnaireSubmit = (data) => {
  return {
    instance: axiosInstance.APIInstance,
    method: "post",
    url: `/user/questionnaireSubmit`,
    body: data,
  };
};

const questionCount = (orgId) => {
  let data = {
    orgId: orgId,
  }
  return {
    instance: axiosInstance.APIInstance,
    method: "post",
    url: `/user/questionCount`,
    body: data
  }
  
}
   
 
const fetchAllgetAllQuestinnaire = () => {
 
  return {
    instance: axiosInstance.APIInstance,
    method: "get",
    url: `/user/questionnaireList`,
  }
}

const deleteQuestionnaire = (body) => {
  return {
    instance: axiosInstance.APIInstance,
    method: "put",
    url: `/user/deleteQuestionnaire`,
    body: body,
  };
};

const editQuestion = (body) => {
  return {
    instance: axiosInstance.APIInstance,
    method: "put",
    url: `/user/editQuestion`,
    body: body,
  };
};

const addOrganizationQuestion = (index,org,user) => {
  const data={
    id:JSON.stringify(index),
    org:Number(org),
    user:user
  }
  return {
    instance: axiosInstance.APIInstance,
    method: "post",
    url: `/user/addOrganizationQuestion`,
    body: data,
  };
};

const getVendorCategoryAssessmentSent = () => {
  return {
    instance: axiosInstance.APIInstance,
    method: "get",
    url: `/dashboard/vendorCategoryAssessmentSent`
  }
}

const getVendorCategoryAssessmentCompleted = () => {
  return {
    instance: axiosInstance.APIInstance,
    method: "get",
    url: `/dashboard/vendorCategoryAssessmentCompleted`
  }
}
const reminderNotification = (data) => {
  return {
    instance: axiosInstance.APIInstance,
    method: "post",
    url: `/user/reminderNotification`,
    body: data,
  };
};

const getIssueManagementFollowUp = (id) => {
  const data={
    status:id,
  }
  return {
    instance: axiosInstance.APIInstance,
    method: "post",
    url: `/dashboard/getIssueManagementFollowUp`,
    body: data
  }
}

const getIssueManagementClose = (id) => {
  const data={
    status:id,
  }
  return {
    instance: axiosInstance.APIInstance,
    method: "post",
    url: `/dashboard/getIssueManagementFollowUpClose`,
    body: data
  }
}

const getVendorHighRiskCategory = () => {
  const data={
    risk:'High',
  }
  return {
    instance: axiosInstance.APIInstance,
    method: "post",
    url: `/dashboard/getVendorHighRiskCategory`,
    body: data
  }
}
const getVendorMediumRiskCategory = () => {
  const data={
    risk:'Medium',
  }
  return {
    instance: axiosInstance.APIInstance,
    method: "post",
    url: `/dashboard/getVendorMediumRiskCategory`,
    body: data
  }
}
const getAssessmentListAdmin = () => {
  return {
    instance: axiosInstance.APIInstance,
    method: "get",
    url: `/user/getAssessmentAdmin`
  };
};

const editAssessorAdmin = (data) => {
  return {
    instance: axiosInstance.APIInstance,
    method: "post",
    url: `/user/editAssessor`,
    body: data
  }
}

const  getAreaWiseSum= (category) => {
  let data = {
    
    category:category
  }
  return {
    instance: axiosInstance.APIInstance,
    method: "post",
    url: `/common/getAreaWiseSum`,
    body: data
  }
}
const getVendorLowRiskCategory = () => {
  const data={
    risk:'Low'
  }
    return {
      instance: axiosInstance.APIInstance,
      method: "post",
    url: `/dashboard/getVendorLowRiskCategory`,
    body: data
  }
}
const handleOrgnizationVendor = (org) => {
  const data={
    org:org
  }
  return {
    instance: axiosInstance.APIInstance,
    method: "post",
    url: `/user/orgVendor`,
    body: data
  }
}

const getAllInherentRisk = () => {
  return {
    instance: axiosInstance.APIInstance,
    method: "get",
    url: `/analyst/getAllInherentRisk`
  };
};

const getScoreData = () => {
 
  return {
    instance: axiosInstance.APIInstance,
    method: "get",
    url: `/analyst/getScoreData`,
  }
}

const getVendorByCategoryAssessmentSentDrilldown = (category) => {
  let data = {
    category: category
  }
  return {
    instance: axiosInstance.APIInstance,
    method: "post",
    url: `/dashboard/getVendorCategoryAssessmentSentDrilldown`,
    body: data
  }
};
const getVendorByCategoryAssessmentCompletedDrilldown = (category) => {
  let data = {
    category: category
  }
  return {
    instance: axiosInstance.APIInstance,
    method: "post",
    url: `/dashboard/getVendorCategoryAssessmentCompletedDrilldown`,
    body: data
  }
};

const getCriticalVendor = () => {
 
  return {
    instance: axiosInstance.APIInstance,
    method: "get",
    url: `/dashboard/getCriticalVendor`,
  }
};

const categoryWiseCriticalityDataAPI = (category) => {
  let data = {
    category: category
  }
  return {
    instance: axiosInstance.APIInstance,
    method: "post",
    url: `/dashboard/categoryWiseCriticalityDataAPI`,
    body: data
  }
};

const categoryWiseCriticalityDueDataAPI = (category,type) => {
  let data = {
    category: category,
    type:type
  }
  return {
    instance: axiosInstance.APIInstance,
    method: "post",
    url: `/dashboard/categoryWiseCriticalityDueDataDetails`,
    body: data
  }
};


const getCompletedPendingAssessment = () => {
  return {
    instance: axiosInstance.APIInstance,
    method: "get",
    url: `/dashboard/getCompletedAgeingAssessment`
  }
}

const getCompletedAssessmentDrilldown = () => {
  return {
    instance: axiosInstance.APIInstance,
    method: "get",
    url: `/dashboard/getCompletedAssessmentDrilldown`
  }
}

const getPendingAssessmentDrilldown = () => {
  return {
    instance: axiosInstance.APIInstance,
    method: "get",
    url: `/dashboard/getPendingAssessmentDrilldown`
  }
}

const getAssessmentSummary = () => {
  return {
    instance: axiosInstance.APIInstance,
    method: "get",
    url: `/dashboard/getAssessmentSummary`
  }
}

const getAssessmentSummaryDrilldown = (param) => {
  let data = {
    param: param
  }
  return {
    instance: axiosInstance.APIInstance,
    method: "post",
    url: `/dashboard/getAssessmentSummaryDrilldown`,
    body: data
  }
}

const getAssessmentSummaryByCategoryDrilldown = (param) => {
  let data = {
    param: param
  }
  return {
    instance: axiosInstance.APIInstance,
    method: "post",
    url: `/dashboard/getAssessmentByCategoryDrilldown`,
    body: data
  }
}

const getAssessmentSummaryByCategory = () => {
  return {
    instance: axiosInstance.APIInstance,
    method: "get",
    url: `/dashboard/getAssessmentSummaryByCategory`
  }
}
const getCategoryDueDate = () => {
 
  return {
    instance: axiosInstance.APIInstance,
    method: "get",
    url: `/dashboard/getCategoryDueDate`,
  }
};

const getCriticalityDueDate = () => {
 
  return {
    instance: axiosInstance.APIInstance,
    method: "get",
    url: `/dashboard/getCriticalityDueDate`,
  }
};

const getCriticalityPerCategory = () => {
  return {
    instance: axiosInstance.APIInstance,
    method: "get",
    url: `/dashboard/getCriticalityPerCategory`
  }
}

const getAssessmentSummaryCriticality = () => {
  return {
    instance: axiosInstance.APIInstance,
    method: "get",
    url: `/dashboard/getAssessmentSummaryCriticality`
  }
}
const getIssuesbyRating = () => {
  const data={
    org:sessionStorage.getItem("orgId")
  }
 
  return {
    instance: axiosInstance.APIInstance,
    method: "post",
    url: `/dashboard/getIssuesbyRating`,
    body:data
  }
};

const getAssessmentbyRating = () => {
  const data={
    org:sessionStorage.getItem("orgId")
  }
 
  return {
    instance: axiosInstance.APIInstance,
    method: "post",
    url: `/dashboard/getAssessmentbyRating`,
    body:data
  }
};

const getCategoryByAssessment = () => {
 
  return {
    instance: axiosInstance.APIInstance,
    method: "get",
    url: `/dashboard/getCategoryByAssessment`,
  }
};

const APIService = {
  getAssessmentSummaryCriticality,
  getCreatedTPRequestsService,
  downloadFile,
  idamSuccess,
  IdamLoginManager,
  verifyIdamLogin,
  getAssessmentUnitUserList,
  getAllControlWorkProgram,
  getAllCtrlWPCategoryList,
  getAllVendorViewIssues,
  getAllViewIssues,
  getAuditsByRoleID,
  getCloseIssuesRequests,
  getCtrlWorkProgramById,
  getEmailsByRoleID,
  getIssueById,
  getManageIssuesRequests,
  getNotifcationsByRoleID,
  getNotifcationsCount,
  getViewActionRequests,
  getViewAllIssues,
  getViewUpdateRequests,
  getmasterWorkPrograms,
  createCtrlWorkProgram,
  deleteCtrlWorkProgramById,
  deleteIssueRequestByID,
  updateCtrlWorkProgram,
  updateViewIssues,
  handleNotificationSubmit,
  approvalViewIssue,
  requestViewIssue,
  closeViewIssue,
  manageViewIssue,
  createmasterWorkProgram,
  loginValidate,
  loginValidateOTP,
  resetPassword,
  resetNewPassword,
  resetNewPasswordEmailValidation,
  clearLoginSession,
  vendorRegistration,
  getAllVendorList,
  getriskvendorlist,
  getAllAssessmentVendorList,
  getAllBusinessUnitList,
  getAllSubBusinessUnitList,
  deleteVendorRecord,
  updateRecordById,
  getVendorRecordsById,
  userRegistration,
  getAllUserList,
  deleteUserRecord,
  getUserRecordsById,
  getRoles,
  getUserList,
  FetchOrgRoles,
  fetchAllOrganizations,
  addNewOrganization,
  editOrganization,
  AddrolesToOrganization,
  deleteOrganization,
  DeleteRoles,
  EditrolesToOrganization,
  getExistRolesById,
  getOrgDetailsById,
  assignUsers,
  fetchSelfAssessmentList,
  getWorkprogramCategoryData,
  fetchUpdateSelfAssessmentList,
  getSelfAssessmentById,
  getUpdatedSelfAssessmentByID,
  getConductedAssessmentData,
  getAssessmentByWPID,
  updateSelfAssessment,
  getAllTPRequests,
  getAnalystWorkPrograms,
  getAssessmentList,
  getTPRequestById,
  getWorkProgramDetailsById,
  createWorkProgram,
  getExcelTableDate,
  createAssessment,
  deleteTPRequest,
  deleteAssessmentPlan,
  addFile,
  saveEvidence,
  saveEvidenceIssue,
  getAllFiles,
  createNewTPRequest,
  getTPDataById,
  updateTPRequest,
  getAllQuestionsList,
  deleteTPRequestData,
  getSelectedVendorAddress,
  getTPListDetails,
  getTPContactInfo,
  getSelectedThirdPartyDetails,
  getPlanRequests,
  getWorkPrograms,
  ...APIServiceExtended,
  selectWorkPrograms,
  updatePlanRequest,
  updateWorkProgramRequest,
  deletePlanRequest,
  deleteWorkProgramRequest,
  getSelfAssessments,
  getOnSiteAssessments,
  getInitiatedOnsiteAssessments,
  initiateSelfAssessment,
  approveSelfAssessment,
  initiateOnsiteAssessment,
  getStatus,
  getAllBUUsersList,
  getAllPriorityLevels,
  getCriticalityList,
  getVendors,
  getCategoryList,
  getManagerEmails,
  getAssessorEmails,
  getProfileDataByUserId,
  getAllBUAssessmentTypeList,
  getAllBUFrequencyList,
  getAllBURecurrenceList,
  getAllManagersList,
  getAllAssessorsList,
  getAllClassifications,
  createRiskRequest,
  getBusinessImpactAnalysis,
  getBIAReviewData,
  getAllRiskData,
  getBusinessImpactByID,
  updateSelectedBusinessImpact,
  updateRiskRequest,
  reviewSelectedBusinessImpact,
  getRiskRequestData,
  getManageRiskData,
  getManageRiskById,
  getAssessmentRiskById,
  getRiskDataById,
  updateManageRiskById,
  getChangeRequestsRiskData,
  getChangeRequestsRiskByID,
  updateRiskRequestById,
  getRiskChangeRequestData,
  getRiskChangeRequestByID,
  updateRiskApprovalById,
  getExistedGraphsData,
  deleteAssessmentPlanByAssessor,
  deleteRiskRequestByID,
  getUnlockUsers,
  unlockUser,
  getUsersListEdit,
  editUsers,
  getAreaWiseCount,
  questionnaireSubmit,
  questionCount,
  fetchAllgetAllQuestinnaire,
  deleteQuestionnaire,
  editQuestion,
  addOrganizationQuestion,
  getVendorCategoryAssessmentSent,
  getVendorCategoryAssessmentCompleted,
  getIssueManagementFollowUp,
  getVendorHighRiskCategory,
  getVendorMediumRiskCategory,
  getVendorLowRiskCategory,
  // reminderNotification
  reminderNotification,
  getAssessmentListAdmin,
  editAssessorAdmin,
  getAreaWiseSum,
  handleOrgnizationVendor,
  getAllInherentRisk,
  getScoreData,
  getIssueManagementClose,
  getVendorByCategoryAssessmentSentDrilldown,
  getVendorByCategoryAssessmentCompletedDrilldown,
  getAllVendorListAdmin,
  getCriticalVendor,
  categoryWiseCriticalityDataAPI,
  getCompletedPendingAssessment,
  getCompletedAssessmentDrilldown,
  getPendingAssessmentDrilldown,
  downloadTemplate,
  getAssessmentSummary,
  getAssessmentSummaryDrilldown,
  getAssessmentSummaryByCategory,
  getCategoryDueDate,
  categoryWiseCriticalityDueDataAPI,
  getCriticalityDueDate,
  getAssessmentSummaryByCategoryDrilldown,
  getCriticalityPerCategory,
  getIssuesbyRating,
  getAssessmentbyRating,
  getCategoryByAssessment
}

export default APIService;
